import router from './router'
import store from './store/index'
const whiteList = ['/login']

router.beforeEach((to, from, next) => {
	// 判断是否有token
	if (store.getters.token) {
		if (to.path === '/login') {
			next({ path: '/' })
		} else {
			next()
		}
	} else {
		if (whiteList.indexOf(to.path) !== -1) {
			// in the free login whitelist, go directly
			next()
		} else {
			let queryStr = ''
			if (Object.keys(to.query).length > 0) {
				queryStr = '?'
				const arr = []
				for (let p in to.query) {
					let str = `${p}=${to.query[p]}`
					arr.push(str)
				}
				queryStr += arr.join('&')
			}
			next(`/login?redirect=${to.path + queryStr}`) // 否则全部重定向到登录页
		}
	}
})

router.afterEach(() => {})
